export default [
  {
    component: "CenteredImage",
    data: {
      image: {
        alt: "chapter-1.slice-0.image.alt",
        // src: require('@/assets/images/chapter-1_slice-0_image.png')
        src: "chapter-1.slice-0.image.src"
      }
    }
  },
  {
    component: "YoutubePlayer",
    data: {
      title: "chapter-1.slice-1.title",
      video: {
        desktop: "chapter-1.slice-1.youtube.desktop",
        mobile: "chapter-1.slice-1.youtube.mobile",
      },
      // cover: {
      //   desktop: "chapter-1.slice-1.image.src",
      //   mobile: "chapter-1.slice-1.image.src"
      // }
    }
  },
  {
    component: "TextImage",
    data: {
      text: {
        description: "chapter-1.slice-2.text.description",
        quote: "chapter-1.slice-2.text.quote",
        author: "chapter-1.slice-2.text.author"
      },
      image: {
        alt: "chapter-1.slice-2.image.alt",
        // src: require('@/assets/images/chapter-1_slice-2_image-1.jpg')
        src: "chapter-1.slice-2.image.src"
      },
    }
  },
  {
    component: "CarouselFull",
    data: {
      title: "chapter-1.slice-3.title",
      description: "chapter-1.slice-3.description",
      carousel: [
        {
          image: {
            alt: "chapter-1.slice-3.item-1.image.alt",
            // src: require('@/assets/images/chapter-1_slice-3_image-1.jpg')
            src: "chapter-1.slice-3.item-1.image.src"
          },
          title: "chapter-1.slice-3.item-1.title",
          subtitle: "chapter-1.slice-3.item-1.subtitle",
          description: "chapter-1.slice-3.item-1.description",
          cta: "chapter-1.slice-3.item-1.cta",
          ctaLabel: "chapter-1.slice-3.item-1.cta_label",
        }, {
          image: {
            alt: "chapter-1.slice-3.item-2.image.alt",
            // src: require('@/assets/images/chapter-1_slice-3_image-2.jpg')
            src: "chapter-1.slice-3.item-2.image.src"
          },
          title: "chapter-1.slice-3.item-2.title",
          subtitle: "chapter-1.slice-3.item-2.subtitle",
          description: "chapter-1.slice-3.item-2.description",
          cta: "chapter-1.slice-3.item-2.cta",
          ctaLabel: "chapter-1.slice-3.item-2.cta_label",
        }, {
          image: {
            alt: "chapter-1.slice-3.item-3.image.alt",
            // src: require('@/assets/images/chapter-1_slice-3_image-3.jpg')
            src: "chapter-1.slice-3.item-3.image.src"
          },
          title: "chapter-1.slice-3.item-3.title",
          subtitle: "chapter-1.slice-3.item-3.subtitle",
          description: "chapter-1.slice-3.item-3.description",
          cta: "chapter-1.slice-3.item-3.cta",
          ctaLabel: "chapter-1.slice-3.item-3.cta_label",
        }, {
          image: {
            alt: "chapter-1.slice-3.item-4.image.alt",
            // src: require('@/assets/images/chapter-1_slice-3_image-4.jpg')
            src: "chapter-1.slice-3.item-4.image.src"
          },
          title: "chapter-1.slice-3.item-4.title",
          subtitle: "chapter-1.slice-3.item-4.subtitle",
          description: "chapter-1.slice-3.item-4.description",
          cta: "chapter-1.slice-3.item-4.cta",
          ctaLabel: "chapter-1.slice-3.item-4.cta_label",
        }, {
          image: {
            alt: "chapter-1.slice-3.item-5.image.alt",
            // src: require('@/assets/images/chapter-1_slice-3_image-5.jpg')
            src: "chapter-1.slice-3.item-5.image.src"
          },
          title: "chapter-1.slice-3.item-5.title",
          subtitle: "chapter-1.slice-3.item-5.subtitle",
          description: "chapter-1.slice-3.item-5.description",
          cta: "chapter-1.slice-3.item-5.cta",
          ctaLabel: "chapter-1.slice-3.item-5.cta_label",
        }
      ]
    }
  },
  {
    component: "TextSimpleSlider",
    data: {
      backgroundColor: 'white',
      left: {
        title: "chapter-1.slice-4.title",
        text: "chapter-1.slice-4.text"
      },
      right: {
        slides: [
          {
            image: {
              alt: "chapter-1.slice-4.item-1.image.alt",
              // src: require('@/assets/images/chapter-1_slice-4_image-1.jpg')
              src: "chapter-1.slice-4.item-1.image.src"
            },
            // caption: "chapter-1.slice-4.item-1.caption",
            title: "chapter-1.slice-4.item-1.title",
            text: "chapter-1.slice-4.item-1.text",
          },
          {
            image: {
              alt: "chapter-1.slice-4.item-2.image.alt",
              // src: require('@/assets/images/chapter-1_slice-4_image-2.jpg')
              src: "chapter-1.slice-4.item-2.image.src"
            },
            // caption: "chapter-1.slice-4.item-2.caption",
            title: "chapter-1.slice-4.item-2.title",
            text: "chapter-1.slice-4.item-2.text",
          },
          {
            image: {
              alt: "chapter-1.slice-4.item-3.image.alt",
              // src: require('@/assets/images/chapter-1_slice-4_image-3.jpg')
              src: "chapter-1.slice-4.item-3.image.src"
            },
            // caption: "chapter-1.slice-4.item-3.caption",
            title: "chapter-1.slice-4.item-3.title",
            text: "chapter-1.slice-4.item-3.text",
          },
        ]
      }
    }
  },
  {
    component: "NextChapter",
    data: {
      image: {
        alt: "chapter-1.next.image.alt",
        // src: require('@/assets/images/chapter-1_next.jpg')
        src: "chapter-1.next.image.src"
      },
      nextChapter: "chapter-1.next.title"
    }
  }
]